module.exports = "<div class=\"programming-nav-container\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/nav-container/nav-container.html
// module id = 1532
// module chunks = 2